<template>
  <custom-select
    v-model="localModel"
    :label="titulo"
    :spanColumn="4"
    :settings="{
      placeholder: 'Seleccionar familia',
      filterable: true,
      inputClass: { 'input-error': validar },
      options: materiaPrimaFamilias,
      disabled: props.disabled,
    }"
  />
</template>

<script setup>
import { storeToRefs } from 'pinia';
import CustomSelect from '@/shared/components/custom_select.vue';
import { useMateriaPrimaFamiliaStore } from '@/stores/materia_prima_familia/materia_prima_familia_store';
import { computed } from 'vue';

const materiaPrimaFamiliaStore = useMateriaPrimaFamiliaStore();
const { materiaPrimaFamilias } = storeToRefs(materiaPrimaFamiliaStore);

const props = defineProps({
  modelValue: { type: Object, required: true },
  titulo: { type: String, default: 'Familia item' },
  validar: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue']);

const localModel = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value);
  },
});
</script>

<style scoped></style>
